import { useEffect, useState } from "react";
import { Select, Tooltip, message } from "antd";
import moment from "moment";
import { serviceApi } from "@/apis";
import "./index.less";
import tipsPng from "@/images/service/balance-tips.svg";
import { strFormatNumber } from "@/utils";

interface CapitalProps {
  segmentOption: DictionarySelectOption[];
  curSegment: string;
  setCurSegment: Function;
  customerCode?: string;
  customerName?: string;
}

const Capital = ({
  segmentOption,
  curSegment,
  setCurSegment,
  customerCode,
  customerName,
}: CapitalProps) => {
  const [balance, setBalance] = useState("-");
  const [decimal, setDecimal] = useState("");

  useEffect(() => {
    if (curSegment && customerCode) {
      serviceApi
        .accountBalance({
          kunnr: customerCode,
          kkber: curSegment,
          paymentDateEnd: moment().format("YYYY-MM-DD"),
        })
        .then((res) => {
          if (res.data && res.data.length > 0) {
            const nowBalList = strFormatNumber(res.data[0].wrbtr).split(".");
            setBalance(nowBalList[0]);
            if (nowBalList && nowBalList.length > 1) {
              setDecimal(`.${nowBalList[1]}`);
            }
          } else {
            message.error(res.message);
          }
        })
        .catch((err) => {
          message.error(err);
        });
    }
  }, [curSegment, customerCode]);

  return (
    <>
      <h4 className="capital-h4">
        资金详情{" "}
        <div>
          签约主体：
          {segmentOption && segmentOption.length > 1 ? (
            <Select
              className="balance-select"
              value={curSegment}
              onChange={(val) => {
                setCurSegment(val);
              }}
              style={{ width: 250 }}
              bordered={false}
              options={segmentOption}
            />
          ) : (
            <span>{segmentOption[0]?.label}</span>
          )}
        </div>
      </h4>
      <div className="capital-content">
        <p className="account">{customerName}</p>
        <p className="balance">
          {balance}
          {decimal ? <span>{decimal}</span> : null}
        </p>
        <p className="balance-tips flex-c-c">
          我的余额(元)
          <Tooltip
            title={
              <p>
                我的余额=已付款-应付款
                <br />
                余额为负：数据代表尚未结清款项
                <br />
                余额为正：数据代表预付款余额
              </p>
            }
          >
            <img src={tipsPng} alt="" />
          </Tooltip>
        </p>
      </div>
    </>
  );
};

export default Capital;
